import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import { Button } from '@mui/material';

export interface FileImportProps {
  accept: string;
  onFileSelected: (file: File) => void;
  label: string;
  enableGlobalDrop?: boolean; // default true
}

const FileImport = forwardRef<{ open: () => void }, FileImportProps>(
  ({ accept, onFileSelected, label, enableGlobalDrop = true }, ref) => {
    const inputRef = useRef<HTMLInputElement>(null);

    useImperativeHandle(ref, () => ({
      open: () => inputRef.current?.click(),
    }));

    const handleClick = () => {
      inputRef.current?.click();
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.files && event.target.files.length > 0) {
        onFileSelected(event.target.files[0]);
        event.target.value = '';
      }
    };

    React.useEffect(() => {
      if (!enableGlobalDrop) return;
      const handleDragOver = (e: DragEvent) => {
        e.preventDefault();
      };
      const handleDrop = (e: DragEvent) => {
        e.preventDefault();
        if (e.dataTransfer?.files && e.dataTransfer.files.length > 0) {
          onFileSelected(e.dataTransfer.files[0]);
        }
      };
      window.addEventListener('dragover', handleDragOver);
      window.addEventListener('drop', handleDrop);
      return () => {
        window.removeEventListener('dragover', handleDragOver);
        window.removeEventListener('drop', handleDrop);
      };
    }, [enableGlobalDrop, onFileSelected]);

    return (
      <>
        <input
          ref={inputRef}
          type="file"
          accept={accept}
          style={{ display: 'none' }}
          onChange={handleChange}
        />
        {/* Button is hidden, only input is needed for programmatic triggering */}
      </>
    );
  }
);

export default FileImport;
